function updateToken(state, token) {
  sessionStorage.token = token;
  state.access_token = token;
}

function updateUid(state, uid) {
  sessionStorage.uid = uid;
  state.uid = uid;
}

function updateheadpicurl(state, url) {
  state.headpicurl = url;
  sessionStorage.headpicurl = url;
}

function updateUserName(state, name) {
  state.userName = name;
  sessionStorage.userName = name;
}

function updatePath(state, name) {
  state.path = name;
  sessionStorage.path = name;
}

function updateLevel (state, name) {
  state.level = name;
  sessionStorage.level = name;
}

function updateCommunity(state, type) {
  sessionStorage.streetorcommunity = type;
  state.streetorcommunity = type;
}

function updateCommunityid(state, id) {
  sessionStorage.streetorcommunityid = id;
  state.streetorcommunityid = id;
}

function updateCityCode(state, cityCode) {
  sessionStorage.cityCode = cityCode;
  state.cityCode = cityCode;
}

function updateCityLatLng(state, cityLatLng) {
  sessionStorage.cityLatLng = cityLatLng;
  state.cityLatLng = cityLatLng;
}

function updateIsAdmin(state, num) {
  state.isAdmin = num;
  sessionStorage.isAdmin = num;
}

function updateUsertypeid(state, id) {
  sessionStorage.usertypeid = id;
  state.usertypeid = id;
}

function updateinitid(state, initid) {
  state.initid = initid;
  sessionStorage.initid = initid;
  state.initid = initid;
}

function updateNavindex(state, navIndex) {
  state.navIndex = navIndex;
  sessionStorage.navIndex = navIndex;
}

function updateSideList(state, sideList) {
  state.sideList = sideList;
  sessionStorage.sideList = sideList;
}

function updateGZHhead(state, head) {
  state.GZHhead = head;
  sessionStorage.GZHhead = head;
}

function updateGZHname(state, name) {
  state.GZHname = name;
  sessionStorage.GZHname = name;
}

function updateSystemName(state, name) {
  state.systemName = name;
}
/* 更新右侧筛选框 */
function updateFilterList(state, filterList) {
  state.filterList = filterList;
}
/* 更新右侧筛选框 */
function updateLabelList(state, labelList) {
  state.labelList = labelList;
}
/* 修改 加载中spin装填 */
function updateSpinShow(state, spinShow) {
  state.spinShow = spinShow;
}
/* 更新侧边栏索引 */
function updateSideIndex(state, index) {
  state.sideIndex = index;
  sessionStorage.sideIndex = index;
}
/* 更新左侧边栏子索引 */
function updateChildrenInd(state, index) {
  state.childrenInd = index;
  sessionStorage.childrenInd = index;
}
/* 导航栏 口号或文本内容 */
function updateNavText(state, text) {
  state.navText = text;
  sessionStorage.navText = text;
}

function updateIsTv(state, bool) {
  state.isTV = bool;
  sessionStorage.isTV = bool;
}

function updateEnroll(state, num) {
  state.enrollment = num;
  sessionStorage.enrollment = num;
}

function updateIsJiedao(state, num) {
  state.isJiedao = num;
  sessionStorage.isJiedao = num;
}
/* 更新导航条 选项 */
function updateNavigator(state, list) {
  console.log(typeof list);
  state.navigatorList = list;
  sessionStorage.navigatorList = list;
}
function updataAllowBack(state, bool) {
  state.allowBack = bool;
  sessionStorage.allowBack = bool;
}
/* 更新系统坐标 */
function updatelocation(state, location) {
  state.location = location;
  sessionStorage.location = location;
}
function updateSwiperTv(state, num) {
  state.swiperTv = num;
}
function updateShequSideBar(state, list) {
  state.shequSideBar = list;
  sessionStorage.shequSideBar = list;
}
// 修改微社区的切换id
function updateMiniCommunityChangeId(state, val) {
  state.miniCommunityChangeId = val;
  sessionStorage.miniCommunityChangeId = val;
}

//获取apptype
function updateApptype(state,val){
  state.apptype = val
  sessionStorage.apptype = val
}

function updateManagerList(state, managerList){
  state.managerList = managerList
  sessionStorage.managerList = JSON.stringify(managerList);
}
function xiaofeiquanVue(state,value) {
  state.xiaofeiquanVue = value
}
function updateUserWorker(state,value){
  state.userWorker = value
}
export default {
  updateManagerList,
  updateToken,
  updateUid,
  updateheadpicurl,
  updateUserName,
  updatePath,
  updateLevel,
  updateCommunity,
  updateCommunityid,
  updateCityCode,
  updateCityLatLng,
  updateIsAdmin,
  updateUsertypeid,
  updateinitid,
  updateNavindex,
  updateSideList,
  updateGZHhead,
  updateGZHname,
  updateSystemName,
  updateFilterList,
  updateLabelList,
  updateSpinShow,
  updateSideIndex,
  updateChildrenInd,
  updateNavText,
  updateIsTv,
  updateEnroll,
  updateIsJiedao,
  updateNavigator,
  updataAllowBack,
  updatelocation,
  updateSwiperTv,
  updateShequSideBar,
  updateMiniCommunityChangeId,
  updateApptype,
  xiaofeiquanVue,
  updateUserWorker
};
